import React from 'react';
import { cs } from '../../../lib/currency';

const TONE = {
  discount: 'text-rose-700',
  credit: 'text-emerald-700',
  paid: 'text-emerald-700',
  refunded: 'text-purple-700',
  processing_fee: 'text-slate-700',
};

const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// iter394 — the ONE invoice statement (fee → discount → credit → balance after
// credit → processing fee → paid → refunded → balance). Lines come from the
// backend `accounting` object so every invoice type, the print page and the
// emails show the same numbers in the same order.
export const InvoiceStatement = ({ accounting, title = 'Invoice Breakdown', testId = 'invoice-statement' }) => {
  if (!accounting || !Array.isArray(accounting.lines)) return null;
  return (
    <div data-testid={testId}>
      {title && <p className="text-sm text-slate-500 mb-2">{title}</p>}
      <div className="rounded-md border border-slate-200 bg-white text-sm divide-y divide-slate-100">
        {accounting.lines.map((ln) => {
          const sign = ln.sign === '-' ? '−' : ln.sign === '+' ? '+' : '';
          const cls = ln.total
            ? 'font-semibold text-slate-900 bg-slate-50'
            : ln.subtotal ? 'font-medium text-slate-800' : (TONE[ln.key] || 'text-slate-700');
          return (
            <div key={ln.key} className={`flex justify-between gap-4 px-3 py-2 ${cls}`} data-testid={`${testId}-row-${ln.key}`}>
              <span>{ln.label}</span>
              <span className="tabular-nums whitespace-nowrap">{sign}{cs()}{fmt(ln.amount)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InvoiceStatement;
